import { Fragment, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { LoadingPage } from "src/components/Common/LoadingPage";


const Authmiddleware = (props:any) => {

  const [loading, setloading] = useState(true);

  useEffect(() => {
    const timeOut = setTimeout(() => {
     setloading(false);
    }, 1000);
    return () => clearTimeout(timeOut);
  } , []);

  if (loading) {
    return <LoadingPage />;
  }
  if (!localStorage.getItem("aToken")) {
    return (
      <Navigate to={{ pathname: "/login"}} />
    );
  }
  return <Fragment>{props.children}</Fragment>;
};

export default Authmiddleware;
